import store from "@/core/services/store";
import { UPDATE_LANGUAGE } from "@/core/services/store/profile.module";

const i18nService = {
  defaultLanguage: "de-de",

  languages: [
    {
      lang: "en-us",
      name: "English",
      flag: process.env.BASE_URL + "media/svg/flags/260-united-kingdom.svg"
    },
    {
      lang: "de-de",
      name: "German",
      flag: process.env.BASE_URL + "media/svg/flags/162-germany.svg"
    }
  ],

  /**
   * Keep the active language in the localStorage
   * @param lang
   */
  async setActiveLanguage(lang) {
    await store.dispatch(UPDATE_LANGUAGE, lang);
  },

  /**
   * Get the current active language
   * @returns {string | string}
   */
  getActiveLanguage() {
    return store.getters.language || this.defaultLanguage;
  }
};

export default i18nService;
